import React from 'react';
import Icon from '../../../components/AppIcon';

const FooterSection = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    // services: [
    //   { label: 'Website Development', href: '#services' },
    //   { label: 'Mobile App Design', href: '#services' },
    //   { label: 'Brand Identity', href: '#services' },
    //   { label: 'E-commerce Solutions', href: '#services' },
    //   { label: 'Digital Marketing', href: '#services' },
    //   { label: 'SEO Optimization', href: '#services' }
    // ],
    company: [
      { label: 'About Us', href: '#about' },
      { label: 'Our Process', href: '#process' },
      { label: 'Portfolio', href: '#portfolio' },
      // { label: 'Pricing', href: '#pricing' },
      { label: 'Testimonials', href: '#testimonials' },
      { label: 'FAQ', href: '#faq' },
      {label: 'Service', href: '#ServicesSection' },
    ],
    support: [
      { label: 'Contact Us', href: '#contact' },
      { label: 'Help Center', href: '#' },
      { label: 'Live Chat', href: '#' },
      { label: 'Project Status', href: '#' },
      { label: 'File Upload', href: '#' },
      { label: 'Request Quote', href: '#contact' }
    ],
    legal: [
      { label: 'Privacy Policy', href: '#' },
      { label: 'Terms of Service', href: '#' },
      { label: 'Cookie Policy', href: '#' },
      { label: 'GDPR Compliance', href: '#' },
      { label: 'Refund Policy', href: '#' },
      { label: 'Service Agreement', href: '#' }
    ]
  };

  const socialLinks = [
    { name: 'Facebook', icon: 'Facebook', href: '#', color: 'hover:text-blue-600' },
    { name: 'Twitter', icon: 'Twitter', href: '#', color: 'hover:text-blue-400' },
    { name: 'LinkedIn', icon: 'Linkedin', href: '#', color: 'hover:text-blue-700' },
    { name: 'Instagram', icon: 'Instagram', href: '#', color: 'hover:text-pink-600' },
    { name: 'YouTube', icon: 'Youtube', href: '#', color: 'hover:text-red-600' },
    { name: 'Dribbble', icon: 'Dribbble', href: '#', color: 'hover:text-pink-500' }
  ];

  const handleLinkClick = (href) => {
    if (href.startsWith('#')) {
      const element = document.getElementById(href.substring(1));
      if (element) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 80;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            {/* Logo */}
            <div className="flex items-center mb-6">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                <Icon name="Zap" size={24} color="white" />
              </div>
              <span className="text-2xl font-bold font-poppins">
                FreelanceHub
              </span>
            </div>

            {/* Description */}
            <p className="text-gray-300 mb-6 leading-relaxed">
              Your one-stop freelance solution for professional services. We connect businesses with vetted talent, ensuring quality results with transparent pricing and guaranteed satisfaction.
            </p>

            {/* Contact Info */}
            <div className="space-y-3 mb-6">
              <div className="flex items-center text-gray-300">
                <Icon name="Mail" size={18} className="mr-3 text-blue-400" />
                <span>hello@freelancehub.com</span>
              </div>
              <div className="flex items-center text-gray-300">
                <Icon name="Phone" size={18} className="mr-3 text-blue-400" />
                <span>+1 (555) 123-4567</span>
              </div>
              <div className="flex items-center text-gray-300">
                <Icon name="MapPin" size={18} className="mr-3 text-blue-400" />
                <span>San Francisco, CA 94102</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className={`w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 transition-colors duration-300 ${social.color} hover:bg-gray-700`}
                  aria-label={social.name}
                >
                  <Icon name={social.icon} size={20} />
                </a>
              ))}
            </div>
          </div>

          {/* Services Links */}
          {/* <div>
            <h3 className="text-lg font-semibold font-poppins mb-6">Services</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => handleLinkClick(link.href)}
                    className="text-gray-300 hover:text-white transition-colors duration-300 text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-semibold font-poppins mb-6">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => handleLinkClick(link.href)}
                    className="text-gray-300 hover:text-white transition-colors duration-300 text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h3 className="text-lg font-semibold font-poppins mb-6">Support</h3>
            <ul className="space-y-3">
              {footerLinks.support.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => handleLinkClick(link.href)}
                    className="text-gray-300 hover:text-white transition-colors duration-300 text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Newsletter Signup */}
        {/* <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-xl font-semibold font-poppins mb-2">
                Stay Updated
              </h3>
              <p className="text-gray-300">
                Get the latest updates on new services, special offers, and freelance tips delivered to your inbox.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="Enter your email address"
                className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <button className="px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-300 flex items-center justify-center">
                <Icon name="Send" size={18} className="mr-2" />
                Subscribe
              </button>
            </div>
          </div>
        </div> */}

        {/* Trust Badges */}
        {/* <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-wrap justify-center items-center gap-8">
            <div className="flex items-center text-gray-400">
              <Icon name="Shield" size={20} className="mr-2 text-green-400" />
              <span className="text-sm">SSL Secured</span>
            </div>
            <div className="flex items-center text-gray-400">
              <Icon name="Lock" size={20} className="mr-2 text-blue-400" />
              <span className="text-sm">GDPR Compliant</span>
            </div>
            <div className="flex items-center text-gray-400">
              <Icon name="Award" size={20} className="mr-2 text-yellow-400" />
              <span className="text-sm">ISO 27001 Certified</span>
            </div>
            <div className="flex items-center text-gray-400">
              <Icon name="CheckCircle" size={20} className="mr-2 text-green-400" />
              <span className="text-sm">Money Back Guarantee</span>
            </div>
          </div>
        </div> */}
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            {/* Copyright */}
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} FreelanceHub. All rights reserved.
            </div>

            {/* Legal Links */}
            <div className="flex flex-wrap justify-center gap-6">
              {footerLinks.legal.map((link, index) => (
                <button
                  key={index}
                  onClick={() => handleLinkClick(link.href)}
                  className="text-gray-400 hover:text-white text-sm transition-colors duration-300"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;